<script setup lang="ts">
import { pageviewCount } from '@waline/client'
import { useCommentConfig } from '../../composables/useCommentConfig';
import { useRoute } from 'vitepress';
import { onMounted } from 'vue';
const props = defineProps<{ path: string }>()
const { options } = useCommentConfig()
const route = useRoute()
const viewFn = function () {
  pageviewCount({
    serverURL: options.value.serverURL,
    path: props.path,
    selector: `[data-path="${props.path}"]`,
    update: route.path === props.path,
  })
}
onMounted(() => {
  viewFn()
})
</script>
<template>
  <span class="" :data-path="props.path"></span>
</template>